import TrackingPage from './views/TrackingPage.vue';

const routes = [
  {
    path: '/track/:type/:code',
    name: 'tracking-public',
    component: TrackingPage,
    meta: {
      title: 'Suivi de livraison - Rapidoo',
      requiresAuth: false, // Public route - no authentication required
      showHeader: false,
      showNav: false,
    },
  },
  {
    path: '/track/:code',
    name: 'tracking-public-code',
    component: TrackingPage,
    meta: {
      title: 'Suivi de livraison - Rapidoo',
      requiresAuth: false, // Public route - no authentication required
      showHeader: false,
      showNav: false,
    },
  },
];

export default routes;
